<div class="card">
  <div class="card-header bp-card-header">
    <i class="fas fa-folder-open fa-widget-icon"></i>
    <p class="font-weight-light bp-text">Billing & Payment History</p>
  </div>
  <div class="card-body">
    <div class="row billing-history-text">
      <dx-data-grid id="gridContainer"
                    [dataSource]="billingAndPaymentHistory"
                    [columns]="['date', 'type', 'amount']"
                    [showColumnLines]="false"
                    [showColumnHeaders]="false"
                    [showRowLines]="true"
                    [rowAlternationEnabled]="true"
                    [showBorders]="false"
                    [masterDetail]="{ enabled: true, template: 'detail' }">
        <dxi-column dataField="date" [width]="175" cssClass="bp-text bp-blue-text"></dxi-column>
        <dxi-column dataField="type" [width]="100" [calculateCellValue]="formatTransactionType" alignment="right" cssClass="noOverFlow"></dxi-column>
        <dxi-column dataField="amount" [calculateCellValue]="formatCurrency" alignment="right" cssClass=""></dxi-column>
        <div *dxTemplate="let bill of 'detail'">
          <div *ngIf="bill.data.type == 'Payment'; else billDetailContent">
            <div class=""><b>Method of Payment:</b></div>
            <div class="" style="margin-left: 1rem;">Direct Deposit</div>
          </div>
          <ng-template #billDetailContent>
            <div class="card inner-card">
              <div class="card-header">
              </div>
              <div class="card-body bp-text">
                <div class="row billing-history-row bill-row">
                  <div class="col-sm-6" style="text-align: center;">
                    Billing Period
                    <br />
                    <b>N/A</b>
                    <br />
                    Jul 5 - Aug 3
                  </div>
                  <div class="col-sm-6">
                    Average Daily Usage
                    <br />
                    <b>0 {{consumptionType}} </b>
                    <br />
                    ( 0 {{consumptionType}} total )
                  </div>
                </div>
                <div class="row billing-history-row bill-row">
                  <div class="col-sm-6">
                    Average Daily Cost
                    <br />
                    <b> 0.00</b>
                  </div>
                  <div class="col-sm-6">
                    This Month's Charges
                    <br />
                    <b>$0.00</b>
                  </div>
                </div>
                <div class="row billing-history-row bill-row">
                  <div class="col-sm-12">
                    <span>View your detailed water usage <a><b>here</b></a></span>
                  </div>
                </div>
                <div class="row billing-history-row bill-row">
                  <div class="col-sm-12">
                    <img class="current-bill-image" src="assets/bill.jpg" />
                    <br />
                    <h4><a class="current-bill-footer bill-image-margin">View Bill</a></h4>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </dx-data-grid>
    </div>
  </div>
  <footer class="blockquote-footer billing-history-footer">
    <div class="row">
      <div class="col-sm-12">
        <div class="card footer-card">
          <h4><a class="bp-link-red float-right" routerLink="/Billing/BillHistory">View More<i class="fas fa-chevron-right view-more-arrow"></i></a></h4>
        </div>
      </div>
    </div>
  </footer>
</div>







// WEBPACK FOOTER //
// ./src/app/billing-history/billing-history.component.html